import { render, staticRenderFns } from "./BellAuthDelete.vue?vue&type=template&id=c563b4f8&scoped=true&"
import script from "./BellAuthDelete.vue?vue&type=script&lang=js&"
export * from "./BellAuthDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c563b4f8",
  null
  
)

export default component.exports